import { odataFetch } from "@/lib/odata-fetch";
import { GetDocumentsLinkedToEntityResponse } from "@/odata/document/DocumentModel";
import { QGetDocumentsLinkedToEntity2 } from "@/odata/document/QDocument";
import { useQuery } from "@tanstack/react-query";
import { documentsKeys } from "./documents-keys";

export interface UseEntityDocuments {
  entityId: string;
  passive?: boolean;
}

export function useEntityDocuments({
  entityId,
  passive = false,
}: UseEntityDocuments) {
  const { data, ...query } = useQuery({
    queryKey: documentsKeys.getEntityDocuments(entityId),
    queryFn: ({ meta }) => fetchEntityDocuments(entityId, meta!.token!),
    enabled: ({ meta }) => !passive && !!meta?.token && !!entityId,
  });

  return {
    documents: data?.value,
    ...query,
  } as const;
}

async function fetchEntityDocuments(entityId: string, token: string) {
  const path = new QGetDocumentsLinkedToEntity2().buildUrl({
    function: {
      EntityId: entityId,
    },
  });

  return odataFetch<GetDocumentsLinkedToEntityResponse>({
    path,
    token,
    service: "Document",
  });
}
